<template>
  <article class="ProductCard" :class="{'ProductCard--obsolete' : isObsolete}">
    <div class="ProductCard__row">
      <img class="ProductCard__picture" :src="thumbURL" />
      <div class="ProductCard__content">
        <div class="flex-filling flex-filling-top"></div>

        <div class="ProductCard__meta"><!-- same as in productDetail component -->
          <IconBase class="ProductCard__bio" v-if="bio" iconName="AB" width="28" height="28"><IconAB /></IconBase>
          <IconBase v-if="gcc" iconName="gcc"><IconGcc /></IconBase>
          <ProductLabels :labels="labels" />
        </div>

        <div class="ProductCard__name">
          {{ name }} {{ year }}<br />
          {{ additional_name }}
        </div>
        <p class="ProductCard__family">
          <span v-if="family">{{ family }}</span>
          <span v-if="family && displayColor"> | </span>
          <span v-if="displayColor">{{ localeColor }}</span>
          <template v-if="capacity">
            <span v-if="capacity === '75cl'"><br />{{ capacity }}</span>
            <span v-else><br /><span class="ProductCard__extra-capacity"> {{ capacityLabel }}</span></span>
          </template>
        </p>
        <div class="flex-filling flex-filling-bottom"></div>
        <div class="ProductCard__footer">
          <span class="ProductCard__special" v-if="hasFreeProducts">{{ offer.products_number }}+{{ offer.products_number_free }} {{ "gratuite" | pluralize(offer.products_number_free) }}</span>
          <span class="ProductCard__special" v-else-if="hasSpecialPrice"> {{ offer.offer_text ? offer.offer_text : "Offre spéciale" }}</span>
          <div class="ProductCard__price">
            <span v-if="!hasSpecialPrice" class="ProductCard__price-prefix">à partir de</span>
            <div v-if="hidden_price" class="ProductCard__hidden-price">N.C.</div>
            <Price v-else :price="bestPrice" />
          </div>
        </div>
        <div v-if="displayLogistic" class="ProductCard__logistic">
          {{ logistic_sender }}
        </div>
        <div v-else style="min-height: 26px;">
          &nbsp;
        </div>
      </div>
    </div>
    <Button v-if="canAddToCart"
      type="button"
      @click.native="addToCart"
      :loading="isLoading"
      class="Button--primary"
    >
      Ajouter à ma commande&nbsp;
      <IconBase iconName="cart"><IconCart /></IconBase>
    </Button>
  </article>
</template>
<script>
import notificationService from "../services/notification";
import productMixin from "../mixins/productMixin";
import ProductLabels from "./ProductLabels";
import Button from "./Button";
import IconGcc from "./icons/IconGcc";
import IconAB from "./icons/IconAB";
import IconCart from "./icons/IconCart";

export default {
  name: "ProductCard",
  mixins: [productMixin],
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    addToCart() {
      this.isLoading = true;

      this.$store.dispatch("cart/addToCart", {
        product_id: this.id,
        quantity: this.orderStep
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          notificationService.error(err.message, err.errors);
        });
    }
  },
  components: {
    ProductLabels,
    Button,
    IconGcc,
    IconAB,
    IconCart
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.ProductCard {
  display: flex;
  flex-flow: column;
  align-items: stretch;
  gap: $global-margin/2;
  height: 100%;
  min-height: 15vh;
  padding: 1em;
  font-size: 1em;
  text-align: left;
  background-color: #fff;
  transition: all 0.16s ease-in-out;
  border-radius: 8px;

  &--obsolete {
    opacity: 0.5;
  }

  &:hover {
    position: relative;
    box-shadow: $hover-shadow;
  }

  &__row {
    display: flex;
    align-items: stretch;
    gap: $global-margin/2;
    flex: 1 0 auto;
  }

  &__meta {
    margin-bottom: $global-margin;
    display: flex;
    flex-flow: wrap;
    align-items: center;
    gap: 0.25em;
  }

  &__bio {
    margin-right: 0.225em;
  }

  &__special {
    display: inline-block;
    min-width: 8em;
    text-align: center;
    padding: 0.5em 0.75em;
    margin-bottom: 0.5em;
    font-size: 0.75em;
    text-transform: uppercase;
    font-weight: 900;
    background-color: $color-secondary;
    color: #fff;
  }

  &__content {
    flex: 1 0 0;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    width: 100%;
  }

  &__picture {
    float: left;
    max-height: 8.4rem;
    margin: auto;
    object-fit: contain;
    object-position: center;
    aspect-ratio: 0.33; /* stylelint-disable-line property-no-unknown */
  }

  &__name {
    font-size: 1em;
    font-weight: 500;
    margin-bottom: 0.5em;
    color: $color-black;
    display: flex;
    align-items: center;

    img,
    svg {
      margin-left: 5px;
    }
  }

  &__family {
    font-size: 0.875em;
    margin: 0;
    line-height: 1;
  }

  &__extra-capacity {
    border-radius: $global-radius / 2;
    font-size: 0.875em;
    font-weight: 700;
    margin-top: 4px;
    padding: 0.2rem;
    display: inline-block;
    background-color: $color-danger;
    color: #fff;
  }

  &__price {
    font-size: 1.625em;
    color: $color-secondary;
    margin-left: auto;

    &-prefix {
      display: block;
      font-size: 0.5em;
      color: $color-grey;
      font-weight: 500;
    }
  }

  &__hidden-price {
    font-weight: 900;
  }

  &__footer {
    margin-top: auto;
    padding-top: $global-margin/2;
  }

  &__logistic {
    text-align: center;
    border-top: 1px solid $color-black;
    font-size: 0.6em;
    text-transform: uppercase;
    padding-top: 7px;
    font-weight: 700;
    margin-top: 7px;
  }

  .Button {
    padding: 0.5em 0.75em;
    font-size: 1em;
  }
}

@media (max-width: 400px) {
  .ProductCard {
    font-size: 0.75rem;
  }
}

@media (min-width: 900px) {
  .ProductCard {
    font-size: 0.875rem;

    &__special {
      font-size: 0.625rem;
    }
  }

  .ProductCard__picture {
    max-height: 12em;
  }

  .ProductCard__footer {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 0.5em;
  }
}

</style>
